import React from 'react';
import { UserFields } from './user_components/UserFields';

export default function NewUser() {
    return <UserFields pageTitle='add_user' />;
}
